module.exports = __webpack_public_path__ + "static/media/1on1Mentoring Package.5ee05ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/1on1Mentoring Package.png
// module id = 2478
// module chunks = 0